import React, { useEffect, useContext, useRef, useState } from "react";
import { Alert, Box, Button, Checkbox, CircularProgress, FormControl, FormControlLabel, TextField , MenuItem ,  Grid, LinearProgress, Paper, selectClasses, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, RadioGroup, Radio } from "@mui/material";
import ApiService from "../../functions/apiService";
import MyTable from "../../components/Schedule/MyTable";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import { useSnackbar } from "notistack";
import ManagementHeaderNav from "../../components/HeadersNav/ManagementHeaderNav";
import { formateDate } from "../../utils/helperFunctions";
import { getGridStringOperators } from "@mui/x-data-grid";
import StatusInTable from "../../components/StatusInTable/StatusInTable";
import CollapseComponent from "../../components/Schedule/CollapseComponent";
import Timer from '../CallBacks/Timer';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CheckIcon from '@mui/icons-material/Check';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import EmptyState from "../../components/Error/EmptyState";
import { useNavigate } from "react-router-dom";
import ShiftWork from "./ShiftWork";
import { varFormatTime } from "../../utils/helperFunctions";
import AuthContext from "../../context/AuthContext";
import { toast } from 'react-toastify';

const CheckboxRenderer = ({
	row,
	setRowSelectionModel,
	setSelectedShift,
	selectedPatch,
	setSelectedPatch,
	rowSelectionModel,
	rowsAll,
	allowedVars
}) => {

	const checked = rowSelectionModel.includes(row.id);

	const allRows = Object.values(rowsAll).flat();
	const hasNullBatchSelected = rowSelectionModel.some((id) => {
		const selectedRow = allRows.find((r) => r.id === id);
		return selectedRow && selectedRow.Batch_Number == null;
	});

	const handleCheckboxChange = (event) => {
		const isChecked = event.target.checked;

		if (isChecked) {
			setSelectedShift(row.Shift_Code);

			if (row.Batch_Number != null) {
				const batchRows = allRows.filter(
					(r) => r.Batch_Number === row.Batch_Number
				);
				setRowSelectionModel((prev) =>
					Array.from(new Set([...prev, ...batchRows.map((r) => r.id)]))
				);
			} else {
				setRowSelectionModel((prev) => Array.from(new Set([...prev, row.id])));
			}

			if (row.Batch_Number != null) {
				setSelectedPatch(row.Batch_Number);
			}
		} else {
			if (row.Batch_Number != null) {
				const batchRows = allRows.filter(
					(r) => r.Batch_Number === row.Batch_Number
				);
				setRowSelectionModel((prev) =>
					prev.filter((id) => !batchRows.some((r) => r.id === id))
				);
			} else {
				setRowSelectionModel((prev) => prev.filter((id) => id !== row.id));
			}

			setRowSelectionModel((prev) => {
				if (prev.length === 0) {
					setSelectedShift(null);
					setSelectedPatch(null);
				}
				return prev;
			});
		}
	};

	if (hasNullBatchSelected && row.Batch_Number != null) {
		return null;
	}

	if (row.Status === "O") {
		return (
			<Checkbox
				color="primary"
				checked={checked}
				onChange={handleCheckboxChange}
			/>
		);
	}

	return null;
};

export default function FillShift() {
	const { user } = useContext(AuthContext);
	const { enqueueSnackbar } = useSnackbar();
	const [loading, setLoading] = useState(true);
	const [submiting, setSubmiting] = useState(false);
	const [submiting2, setSubmiting2] = useState(false);
	const [rows, setRows] = useState([]);
	const [error, serError] = useState('');
	//const [NotifiByOne, setNotifiByOne] = useState(false);
	//const [NotifiInEnd, setNotifiInEnd] = useState(false);
	const [batchNotification, setBatchNotification] = useState('None');
	const [rowSelectionModel, setRowSelectionModel] = useState([]);
	const [viewJobs, setViewJobs] = useState(false);
	const [viewJobsEmp, setViewJobsEmp] = useState([]);
	const [viewJobsEmpDiscard, setViewJobsEmpDiscard] = useState([]);
	const [ProgressValue, setProgressValue] = useState(0);
	const [selectedShift, setSelectedShift] = useState();
	const [selectedPatch, setSelectedPatch] = useState(null);
	const [patchId, setPatchId] = useState('');
	const [backMode, setBackMode] = useState(true);
	const [fromPreAccept, setFromPreAccept] = useState(false);
	const [returnbatches, setReturnbatches] = useState([]);
	const intervalId = useRef(null);
	const [expandAll, setExpandAll] = useState(true);
	const [anyExpanded, setAnyExpanded] = useState(true);
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const navigate = useNavigate();
	const [allowedVars , setAllowedVars] = useState({})
	const [timerType, setTimerType] = useState('Seconds');
	const [timer, setTimer] = useState(5);
	const [overtimeList , setOvertimeList] = useState([]);
	const [chosenOV , setChosenOV] = useState('default');

	let getAllowedVars = () => {
		ApiService.get('/v3Variables')
			.then((res) => {
					setAllowedVars(res?.data?.data)
			}).catch(({ error }) => {
					console.log('error', error)
		});
	}

	useEffect(()=>{
		getAllowedVars();
	}, [])

	useEffect(() => {
		if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS) {
				if(allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS >= 60){
					setTimerType('Minutes')
					if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS == 60) {
						setTimer(1);
					} else if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS == 120) {
						setTimer(2);
					} else if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS == 180) {
						setTimer(3);
					} else if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS == 240) {
						setTimer(4);
					} else if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS == 300) {
						setTimer(5);
					} else if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS == 360) {
						setTimer(6);
					} else if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS == 420) {
						setTimer(7);
					} else if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS == 480) {
						setTimer(8);
					} else if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS == 540) {
						setTimer(9);
					} else if (allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS == 600) {
						setTimer(10);
					}
					else{
						setTimerType('Seconds')
						setTimer(parseInt(allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS));
					}
				}
				else{
					setTimerType('Seconds')
					setTimer(parseInt(allowedVars.V3_DEFAULT_FILL_DURATION_SECONDS));
				}
		} else {
			setTimerType('Seconds')
			setTimer(5);
		}
	}, [allowedVars]);

	useEffect(() => {
		if (timerType == 'Minutes') {
			localStorage.setItem('Timer', JSON.stringify([timer * 60]));
		}
		else {
			localStorage.setItem('Timer', JSON.stringify([timer]));
		}
	}, [timer, timerType]);

	const toggleAllCollapses = () => {
		setExpandAll(prev => !prev);
		if (!expandAll) {
			setAnyExpanded(true);
		}
		else {
			setAnyExpanded(false);
		}
	};

	const handleExpandChange = (isExpanded) => {
		if (isExpanded) {
			setAnyExpanded(true);
		}
		else {
			setAnyExpanded(false);
		}
	};

	let getOvertimeList = () => {
		ApiService.get('/getOverTimeListDDL', {}, 'getOverTimeListDDL').then(({ data }) => {
			setOvertimeList(data)
		}).catch(() => {
			toast.error("Error")
		})
	}

	useEffect(()=>{
		getOvertimeList();
	}, [])

	let columns = [
		{
			field: 'customCheckbox',
			headerName: '',
			sortable: false,
			width: 50,
			filterable: false,
			renderCell: (params) => {
				if(allowedVars?.V3_FILL_SHIFT_OPTION == "daynighttogether"){
					if ((selectedPatch == null || selectedPatch == params.row.Batch_Number)) {
						return <>
							<CheckboxRenderer
								rowsAll={rows}
								setRowSelectionModel={setRowSelectionModel}
								rowSelectionModel={rowSelectionModel}
								setSelectedShift={setSelectedShift}
								selectedPatch={selectedPatch}
								setSelectedPatch={setSelectedPatch}
								allowedVars={allowedVars}
								{...params}
							/>
						</>
					}
				}
				else if (
					(selectedShift == null || selectedShift.toString() == params.row.Shift_Code.toString()) 
					&& (selectedPatch == null || selectedPatch == params.row.Batch_Number)) {
					return <>
						<CheckboxRenderer
							rowsAll={rows}
							setRowSelectionModel={setRowSelectionModel}
							rowSelectionModel={rowSelectionModel}
							setSelectedShift={setSelectedShift}
							selectedPatch={selectedPatch}
							setSelectedPatch={setSelectedPatch}
							allowedVars={allowedVars}
							{...params}
						/>
					</>
				}
			},
		},
		{
			field: 'Batch_Number', headerName: 'Batch', flex: 1, minWidth: 140, cellClassName: 'space-cutter-class',
			filterable: false,
			renderCell: (params) => <span style={{ fontSize: '14px' }}>{params.value}</span>,
		},
		{
			field: 'Orig_Emp_Position', headerName: 'Position', flex: 1, minWidth: 120, cellClassName: 'space-cutter-class',
			filterOperators: getGridStringOperators().filter(
				(operator) => operator.value === "contains"
			),
			renderCell: (params) => <span style={{ fontSize: '14px' }}>{params.value}</span>,
		},
		{
			field: 'Orig_Emp_fullName', headerName: 'Name', flex: 1, minWidth: 140, cellClassName: 'space-cutter-class',
			filterOperators: getGridStringOperators().filter(
				(operator) => operator.value === "contains"
			)
			,
			valueGetter: (params) => {
				if (params.row.Detail_Type === null) {
					return params.row.Orig_Emp_EA_Rank + ' ' + params.row.Orig_Emp_fullName;
				} else {
					return 'Detail';
				}
			},
			renderCell: (params) => <span style={{
				whiteSpace: 'normal',
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				lineHeight: '1.5',
				wordBreak: 'break-word'
			}}>{params.value}</span>,
		},
		{
			field: 'Shift_List',
			headerName: 'Shift/List',
			flex: 1,
			minWidth: 250,
			cellClassName: 'space-cutter-class',
			valueGetter: (params) => {
				let shiftValue = '';
				if (params.row.Shift_Code === 1) {
					shiftValue = '24';
				} else if (params.row.Shift_Code === 2) {
					shiftValue = 'Day';
				} else if (params.row.Shift_Code === 3) {
					shiftValue = 'Night';
				} else if (params.row.Shift_Code === 91) {
					shiftValue = `${varFormatTime(`${params.row.Start_Time}-${params.row.End_Time}`, user?.Time_Format)}`;
					// shiftValue = params.row.Start_Time + " -  " + params.row.End_Time;
				} else if (params.row.Shift_Code === 0) {
					shiftValue = `${varFormatTime(`${params.row.Start_Time}-${params.row.End_Time}`, user?.Time_Format)}`;
					// shiftValue = params.row.Start_Time + " -  " + params.row.End_Time;
				}
				else if (params.row.Shift_Code > 3 && params.row.Shift_Code < 90) {
					shiftValue = params.row.Shift_Details;
				}

				if (params.row.Shift_Code === 91) {
					const overtimeList = params.row.Overtime_List || '';
					return `${shiftValue}`;
				} else {
					const overtimeList = params.row.Overtime_List || '';
					return `${shiftValue}`;
				}

			},
			renderCell: (params) => (
				<span style={{ fontSize: '14px' }}>
					{params.value}
				</span>
			),
		},
		{
			field: 'Reason', headerName: 'Reason', flex: 1, minWidth: 100, cellClassName: 'space-cutter-class',
			filterOperators: getGridStringOperators().filter(
				(operator) => operator.value === "contains"
			),
			valueGetter: (params) => {
				if (params.row.Detail_Type === null) {
					return params.row.Reason
				}
				else {
					return params.row.Detail_Type + ' ' + params.row.Reason
				}
			},
			renderCell: (params) => <span style={{ fontSize: '14px', whiteSpace: 'normal', wordBreak: 'break-word', }}>{params.value}</span>,
		},
		{
			field: 'StatusText', headerName: 'Status', flex: 1, minWidth: 100,
			filterable: false,
			renderCell: (params) => {
				if (params.row.StatusText) {
					return (<StatusInTable StatusText={params.row.StatusText} StatusColor={params.row.StatusColor} />);
				}
				return <span></span>;
			},
		},
		{
			field: 'Paged_Time', headerName: 'Last Page', flex: 1, minWidth: 100, cellClassName: 'space-cutter-class',
			filterable: false,
			renderCell: (params) => <span style={{ fontSize: '14px' }}>{params.value}</span>,
		},
	];

	const handlePreSubmit = () => {
		setLoading(true);
		setSubmiting2(true);
		let selectedRows = Object.keys(rows)
			.map(dateKey =>
				rows[dateKey]
					.filter(item => rowSelectionModel.includes(item.id))
					.map(item => [item.Shift_Number, item.Shift_Date])
			).flat();

		ApiService.post("/postFillShiftToList", {
			"shifts": selectedRows,
			"otList" : chosenOV,
		})
			.then((data) => {
				setLoading(false);
				handleSubmit();
				setSubmiting2(false);
			})
			.catch(({ data }) => {
				setLoading(false);
				toast.error(data?.message);
				setSubmiting2(false);
			});
	};

	let handleSubmit = () => {
		let RequestTimer = timer;
		if (timerType == 'Minutes') {
			RequestTimer = RequestTimer * 60;
		}
		if (RequestTimer < 5) {
			toast.error('Timer cannot be less than 5 seconds')
			return;
		}
		setLoading(true);
		setBackMode(true);
		if (Number.isInteger(timer)) {
			if (rowSelectionModel.length > 0) {
				serError('');
				setSubmiting(true);

				let selectedRows = Object.keys(rows)
					.map(dateKey =>
						rows[dateKey]
							.filter(item => rowSelectionModel.includes(item.id))
							.map(item => [item.Shift_Number, item.Shift_Date])
					).flat();

				ApiService.post('/fillShiftStartRevamp', {
					"Shifts": selectedRows,
					"Timer": RequestTimer,
					"BatchNotificationType" : batchNotification,
					//"NotifiByOne": NotifiByOne == 'true' || NotifiByOne == true ? true : false,
					//"NotifiInEnd": NotifiInEnd == 'true' || NotifiInEnd == true ? true : false,
					"batchId": selectedPatch,
				}).then((response) => {
					setLoading(false);
					toast.success('Fill Shift Started')
					const data = response.result;
					const batch_id = selectedPatch;
					const batch_id_new = response.batch_id;
					const job_id = response.job_id;

					if (!batch_id) {
						navigate(`/firehouse/fill-shift-work/${batch_id_new}/${job_id}`);
					}
					else {
						navigate(`/firehouse/fill-shift-work/${batch_id}/${job_id}`);
					}
					let patchIds = [];
					data.forEach(item_data => {
						if (item_data.message) {
							setFromPreAccept(true);
							setViewJobs(true);
							setViewJobsEmp(item_data.emp);
							setProgressValue(100);
							// enqueueSnackbar(item_data.message, { variant: 'success' });
						} else {
							if (item_data.options.emp.length > 0) {
								if (item_data.jobs.length > 0) {
									patchIds.push(item_data.jobs[0]['batchId']);
								}
							}
						}
					});

					setReturnbatches(patchIds)
					// if (intervalId.current == null) {
					//   intervalId.current = setInterval(() => getJobData(patchIds), 8000);
					// }
				}).catch((e) => {
					setLoading(false);
					clearInterval(intervalId.current);
					setProgressValue(100);
					setSubmiting(false);
					setPatchId('');
					// toast.error(e?.data?.message || 'Some error occured')
				});
			} else {
				serError('Must select Shift');
			}
		} else {
			serError('time must be number');
		}
	};

	let loadData = () => {
		setLoading(true);
		ApiService.get('/getShiftsToFill', {}, 'getShiftsToFill').then(({ data }) => {
			setRows(data);
			setLoading(false);
		}).catch((e) => {
			setLoading(false);
			toast.error("Error")
		})
	}

	function handleRadioClick(event) {
    if (event.target.value === batchNotification) {
      setBatchNotification("None");
    } 
  }

	useEffect(() => {
		loadData()
	}, [])

	useEffect(() => {
		if (patchId != '' && backMode) {
			setViewJobs(true);
		}
	}, [patchId, backMode])


	// const CheckboxRenderer = ({
	//   row,
	//   rowSelectionModel = [],
	//   setRowSelectionModel,
	//   setSelectedShift,
	//   setSelectedPatch,
	//   rowsAll,
	//   }) => {

	// const checked = Array.isArray(rowSelectionModel) && rowSelectionModel.includes(row.id);

	// const handleChange = (event) => {
	//   handleSelectionToggle(
	//     event,
	//     row,
	//     rowSelectionModel,
	//     setRowSelectionModel,
	//     setSelectedShift,
	//     setSelectedPatch,
	//     rowsAll
	//   );
	// };

	// if (row.Status === "O") {
	//   return <Checkbox color="primary" checked={checked} onChange={handleChange} />;
	// }
	// return null;
	// };

	// const handleSelectionToggle = (
	//   event,
	//   row,
	//   rowSelectionModel,
	//   setRowSelectionModel,
	//   setSelectedShift,
	//   setSelectedPatch,
	//   rowsAll
	// ) => {

	//   const isChecked = event.target ? event.target.checked : !rowSelectionModel.includes(row.id);
	//   if (isChecked) {
	//     setSelectedShift(row.Shift_Code);

	//     if (row.Batch_Number != null) {
	//       Object.keys(rowsAll).forEach((key) => {
	//         const array = rowsAll[key];
	//         array.forEach((i) => {
	//           if (i.Batch_Number === row.Batch_Number) {
	//             setRowSelectionModel((prev) => Array.from(new Set([...prev, i.id])));
	//           }
	//         });
	//       });
	//     } else {
	//       setRowSelectionModel((prev) => Array.from(new Set([...prev, row.id])));
	//     }

	//     if (row.Batch_Number != null) {
	//       setSelectedPatch(row.Batch_Number);
	//     }
	//   } else {
	//     if (rowSelectionModel.length === 1) {
	//       setSelectedShift();
	//       setSelectedPatch(" ");
	//     }

	//     setRowSelectionModel((prev) => {
	//       const index = prev.indexOf(row.id);
	//       if (index > -1) {
	//         prev.splice(index, 1);
	//       }
	//       return Array.from(new Set([...prev]));
	//     });
	//   }
	// };

	// const handleRowClick = (
	//   row,
	//   rowSelectionModel,
	//   setRowSelectionModel,
	//   setSelectedShift,
	//   setSelectedPatch,
	//   rowsAll
	// ) => {

	//   if (row?.row?.Status !== "O") {
	//     return; 
	//   }

	//   const checkboxEvent = { target: { checked: !rowSelectionModel.includes(row?.row?.id) } };
	//   handleSelectionToggle(
	//     checkboxEvent,
	//     row,
	//     rowSelectionModel,
	//     setRowSelectionModel,
	//     setSelectedShift,
	//     setSelectedPatch,
	//     rowsAll
	//   );
	// };


	return (
		<>
			<ManagementHeaderNav />
			<Box style={{ marginTop: "1rem" }}>
				<Grid container spacing={2} columns={{ xs: 8, sm: 8, md: 12 }}>
					{!viewJobs &&
						<Grid item xs={12}>
							<Paper className="p-3">
								<Typography variant="h6">Fill Overtime</Typography>
								<div className="pt-3">
									<Box>
										<Grid container>
											<Grid item xs={12} md={4.5}>
												<label className="h6 text-black" style={{ fontSize: '14px' }}>Notifications</label>
												<div>
													<FormControl>
														<RadioGroup value={batchNotification} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
															<FormControlLabel
																control={
																	<Radio
																		value='All'
																		onChange={(e) => setBatchNotification(e.target.value)}
																		onClick={handleRadioClick}
																		color="red"
																	/>
																}
																label="Notify when all shifts are filled"
																sx={{ '& .MuiFormControlLabel-label': { fontSize: '12px' } }}
															/>
															<FormControlLabel
																control={
																	<Radio
																		value='Each'
																		onChange={(e) => setBatchNotification(e.target.value)}
																		onClick={handleRadioClick}
																		color="red"
																	/>
																}
																label="Notify when each shift is filled"
																sx={{ '& .MuiFormControlLabel-label': { fontSize: '12px' } }}
															/>
														</RadioGroup>
													</FormControl>
												</div>
											</Grid>
											<Grid item xs={12} md={5.5} sx={{ marginTop: isMobile ? '15px' : '' }}>
												<label className="h6 text-black" style={{ fontSize: '14px' }}>Time interval</label>
												<div style={{ display: isMobile ? '' : 'flex', flexDirection: isMobile ? '' : 'row' }}>
													<div className="input-group" style={{ maxWidth: '160px', marginRight: '10px', maxHeight: '34px', marginTop: '4px' }}>
														<input type="text" className="form-control shadow-none"
															style={{ maxWidth: '60px', fontSize: '12px' }}
															value={timer}
															// onChange={(e) => setTimer(Number(e.target.value))} />
															onChange={(e) => {
																const value = e.target.value;
																if (value === '') {
																	setTimer(0);
																} else if (/^\d+$/.test(value)) {
																	setTimer(Number(value));
																}
															}} />
														<select className="form-select shadow-none" style={{ fontSize: '12px' , cursor:'pointer' }}
															value={timerType}
															onChange={(e) => setTimerType(e.target.value)}>
															<option value="Seconds">Seconds</option>
															<option value="Minutes">Minutes</option>
														</select>
													</div>
													<Box sx={{ marginTop: isMobile ? '10px' : '' }}>
														<Button className='mx-1 my-1' style={{ fontSize: '12px' }} variant="outlined" color='secondary' onClick={(e) => { setTimer(10); setTimerType('Minutes') }}>10 min</Button>
														<Button className='mx-1 my-1' style={{ fontSize: '12px' }} variant="outlined" color='secondary' onClick={(e) => { setTimer(5); setTimerType('Minutes') }}>5 min</Button>
														<Button className='mx-1 my-1' style={{ fontSize: '12px' }} variant="outlined" color='secondary' onClick={(e) => { setTimer(2); setTimerType('Minutes') }}>2 min</Button>
														<Button className='mx-1 my-1' style={{ fontSize: '12px' }} variant="outlined" color='secondary' onClick={(e) => { setTimer(1); setTimerType('Minutes') }}>Last Minute</Button>
													</Box>
												</div>
											</Grid>

											<Grid item sm={6} md={2} sx={{ marginTop: '28px' }}>
												<ButtonTheme
													color='primary'
													disabled={submiting || rowSelectionModel.length == 0 || chosenOV != 'default'}
													onClick={handleSubmit}
													className='mx-4'
												>{submiting ? 'Loading....' : 'Fill Shift'}
											</ButtonTheme>

												{Object.keys(rows).length >= 1 ? <>
													<Box
														component="img"
														src={anyExpanded ? '/images/collapse.svg' : '/images/expand.svg'}
														alt="Icon"
														onClick={toggleAllCollapses}
														style={{ cursor: 'pointer', width: '22px', height: '22px' }}
													/>
												</> : ''}
											</Grid>

											{allowedVars?.V3_OT_LIST_EDITABLE &&
												<Grid item xs={12} sm={12} md={2} style={{marginTop:'16px'}}>
													<label style={{ fontSize: '14px' }}>Overtime List</label>
													<Box className='mt-1'>
														<select className="form-select shadow-none" style={{ fontSize: '12px' , padding:'10px' , cursor:'pointer' }}
															value={chosenOV || ''}
															onChange={(e) => setChosenOV(e.target.value)}
															disabled={selectedPatch !== null}
														>
															<option value='default'>Please select</option>
															{overtimeList.map(type => (
																<option value={type.Overtime_List}>{type.Overtime_List_Description} </option>
															))}
														</select>
													</Box>
												</Grid>
											}

											{allowedVars?.V3_OT_LIST_EDITABLE &&
												<Grid item sm={6} md={3} sx={{ marginTop: '44px' }}>
													<ButtonTheme
														color='primary'
														disabled={submiting2 || rowSelectionModel.length == 0 || selectedPatch !== null || chosenOV == 'default'}
														onClick={handlePreSubmit}
														className='mx-4'
													>{submiting2 ? 'Loading....' : 'Update List & Fill Shift'}
													</ButtonTheme>
												</Grid>	
											}		

										</Grid>
									</Box>
									<p className="text-danger">{error}</p>
								</div>
							</Paper>
						</Grid>
					}
					<Grid item xs={12}>
						{loading &&
							<Paper className="w-100 d-flex justify-content-center align-items-center py-4"
								style={{ height: '410px' }}>
								<CircularProgress />
								{submiting &&
									<Box className='mx-4'>
										<h6>Please Wait for Processing to Complete</h6>
									</Box>
								}
							</Paper>
						}

						{!loading && !viewJobs &&
							<Paper className="p-3" sx={{ maxWidth: '93vw', overflowX: 'auto', background: '#FFF' }}>
								{Object.keys(rows).length === 0 ?
									<div className='d-flex align-items-center' style={{ height: 380 }}>
										<EmptyState />
									</div> :
									Object.keys(rows).map((dateKey) => (
										<CollapseComponent
											key={dateKey}
											name={formateDate(dateKey)}
											rows={rows[dateKey]}
											columns={columns}
											hideFooter={true}
											useTopFilter={true}
											open={expandAll}
											onExpandChange={handleExpandChange}
											checkboxSelection={false}
										// onRowClick={(row) =>
										//   handleRowClick(
										//     row,
										//     rowSelectionModel,
										//     setRowSelectionModel,
										//     setSelectedShift,
										//     setSelectedPatch,
										//     rows,
										//   )
										// }
										/>
									))}
							</Paper>
						}

						{!loading && !submiting && viewJobs && viewJobsEmp.length > 0 && viewJobsEmpDiscard.length > 0 &&
							<ShiftWork />
						}
					</Grid>
				</Grid>
			</Box>
		</>)
}
